var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { reduxBind } from 'badphraim/redux/Common';
import { CerumIcon } from 'common-uicomponents/components/CerumIcon';
import { LitElement, html, css } from 'lit';
import { customElement, state, property } from 'lit/decorators.js';
import { BoostPortalStore } from '../../redux/BoostPortalStore';
import { litReduxBoostPortalMixin } from '../../redux/LitReduxBoostPortalMixin';
let BoostHamburgerMenu = class BoostHamburgerMenu extends litReduxBoostPortalMixin(LitElement) {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.menuItems = [];
        this.toggleDropdown = false;
    }
    static get is() {
        return 'boost-hamburger-menu';
    }
    render() {
        return html `
            <div
                class="hamburger-button"
                tabindex="${this.disabled ? -1 : 0}"
                @click=${() => this._toggle()}
                @keypress=${(event) => this._onKeyPress(event)}
            >
                <cerum-icon icon="vaadin:menu"></cerum-icon>
            </div>
            <div class="hamburger-dropdown" ?open=${this.toggleDropdown}>
                ${[
            {
                title: 'Gå til hovedmeny',
                icon: 'vaadin:home',
                callback: () => this._onNavigateToHomepage(),
            },
            ...this.menuItems,
        ].map((item) => html `
                        <div
                            class="menu-item"
                            ?disabled=${item.disabled}
                            @click=${() => this._onItemClick(item)}
                        >
                            ${item.icon ? html `<cerum-icon icon=${item.icon}></cerum-icon>` : ''}
                            ${item.title}
                        </div>
                    `)}
            </div>
        `;
    }
    _onNavigateToHomepage() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.centerShort) {
                return;
            }
            window.location.href = `${window.location.origin}/${this.centerShort}`;
        });
    }
    _toggle() {
        if (this.disabled) {
            return;
        }
        this.toggleDropdown = !this.toggleDropdown;
    }
    _onKeyPress(event) {
        if (this.disabled) {
            return;
        }
        if (event.key === 'Enter') {
            event.preventDefault();
            this._toggle();
        }
    }
    _onItemClick(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (item.disabled) {
                return;
            }
            this.toggleDropdown = false;
            yield item.callback();
        });
    }
};
BoostHamburgerMenu.deps = [CerumIcon];
BoostHamburgerMenu.styles = css `
        :host {
            position: relative;
            display: inline-block;
        }

        .hamburger-button {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            padding: 8px;
            border-radius: 6px;
            transition: background-color 0.2s;
            user-select: none;
        }

        .hamburger-button cerum-icon {
            --cerum-icon-width: 22px;
            --cerum-icon-height: 22px;
        }

        .hamburger-button:hover {
            background-color: rgba(0, 0, 0, 0.05);
        }

        cerum-icon {
            --cerum-icon-width: 24px;
            --cerum-icon-height: 24px;
            color: var(--portalForeground, #000);
        }

        .hamburger-dropdown {
            position: absolute;
            top: 100%;
            right: 0;
            background: var(--portalBackground, #fff);
            border: 1px solid rgba(0, 0, 0, 0.15);
            border-radius: 4px;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
            overflow: hidden;
            max-height: 0;
            opacity: 0;
            transform: translateY(-10px);
            transition:
                max-height 0.3s ease,
                opacity 0.3s ease,
                transform 0.3s ease;
            min-width: 180px;
            z-index: 100;
        }

        .hamburger-dropdown[open] {
            max-height: 500px;
            opacity: 1;
            transform: translateY(0);
        }

        .menu-item {
            display: flex;
            align-items: center;
            padding: 8px 12px;
            cursor: pointer;
            transition: background-color 0.2s;
        }

        .menu-item:hover {
            background-color: rgba(0, 0, 0, 0.05);
        }

        .menu-item[disabled] {
            cursor: default;
            opacity: 0.5;
        }

        .menu-item cerum-icon {
            margin-right: 8px;
            --cerum-icon-width: 16px;
            --cerum-icon-height: 16px;
        }
    `;
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], BoostHamburgerMenu.prototype, "disabled", void 0);
__decorate([
    property({ type: Array }),
    __metadata("design:type", Array)
], BoostHamburgerMenu.prototype, "menuItems", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], BoostHamburgerMenu.prototype, "toggleDropdown", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('centerShort')),
    state(),
    __metadata("design:type", String)
], BoostHamburgerMenu.prototype, "centerShort", void 0);
BoostHamburgerMenu = __decorate([
    customElement(BoostHamburgerMenu.is)
], BoostHamburgerMenu);
export { BoostHamburgerMenu };
